import { doesUserHaveReleaseToggle } from '@skyspecs/release-utils-client';
import { useAtomValue } from 'jotai';
import React, { useState } from 'react';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';

import { releaseTogglesAtom } from 'utils/account/atoms';
import {
  type HorizonTheme,
  LegacyThemes,
  Theme,
  Themes,
  ThemeStorageKey,
} from 'utils/color/horizonTheme';
import { HORIZON_RESKIN } from 'utils/release-toggles';
import { getItem as getStorageItem, setItem as setStorageItem } from 'utils/storage';

export const ThemeProvider: React.FC<{ theme: Omit<HorizonTheme, 'onChange'> }> = ({
  children,
  ...props
}) => {
  const releaseToggles = useAtomValue(releaseTogglesAtom);
  const hasHorizonGridVisualRefresh = doesUserHaveReleaseToggle({ releaseToggles }, HORIZON_RESKIN);
  const availableThemes = hasHorizonGridVisualRefresh ? Themes : LegacyThemes;
  const [currentThemeName, setCurrentThemeName] = useState<Theme>(
    (getStorageItem(ThemeStorageKey) ?? Theme.Light) as Theme
  );

  const handleChange = (themeName: Theme) => {
    setCurrentThemeName(themeName);
    setStorageItem(ThemeStorageKey, themeName);
  };

  return (
    <StyledComponentsThemeProvider
      {...props}
      theme={{
        ...availableThemes[currentThemeName],
        onChange: handleChange,
      }}
    >
      {children}
    </StyledComponentsThemeProvider>
  );
};
